import { FC } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { Box, useMediaQuery, useTheme } from '@mui/material'

import { UserProfile } from 'components/User'
import Dashboard from 'layouts/Dashboard'

const pathsWithExcludedDesktopView = ['personal-data-confirmation-form']

// Layout for the Profile / settings section ("Panel Klienta 3.0" redesign).
// Desktop: Figma split — white profile nav + grey content pane.
// Mobile: profile screen on the root path, full-screen subpages elsewhere.
const UserLayout: FC = () => {
  const theme = useTheme()
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'))
  const { pathname } = useLocation()

  if (pathsWithExcludedDesktopView.some((item) => pathname.includes(item))) {
    return (
      <Dashboard noHeader disableGutters>
        <Box
          sx={{
            backgroundColor: theme.r4r.greyBg,
            minHeight: '100vh',
            py: { xs: 0, md: '40px' },
            px: { xs: 0, md: '40px' },
            pb: { xs: '24px', md: '64px' }
          }}>
          <Box
            sx={{
              maxWidth: '760px',
              mx: 'auto',
              backgroundColor: { xs: 'transparent', md: '#fff' },
              boxShadow: { md: theme.r4r.cardShadow },
              p: { xs: 0, md: '28px' }
            }}>
            <Outlet />
          </Box>
        </Box>
      </Dashboard>
    )
  }

  if (isDesktop) {
    return (
      <Dashboard noHeader disableGutters>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'stretch',
            minHeight: 'calc(100vh - 56px)',
            backgroundColor: theme.r4r.greyBg
          }}>
          <Box
            sx={{
              width: { md: '360px', lg: '440px' },
              flexShrink: 0,
              backgroundColor: '#fff',
              borderRight: `1px solid ${theme.r4r.greyLight}`,
              display: 'flex',
              flexDirection: 'column'
            }}>
            <UserProfile />
          </Box>
          <Box
            sx={{
              flex: 1,
              minWidth: 0,
              overflow: 'auto',
              px: '48px',
              pt: '36px',
              pb: '48px'
            }}>
            <Outlet />
          </Box>
        </Box>
      </Dashboard>
    )
  }

  if (pathname === '/user') {
    return (
      <Dashboard noHeader>
        <Box sx={{ backgroundColor: theme.r4r.greyBg, minHeight: '100vh', pb: '24px' }}>
          <Outlet />
        </Box>
      </Dashboard>
    )
  }

  return <Outlet />
}

export default UserLayout
